import React from 'react';
import PageMeta from '../components/common/PageMeta';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import Footer from "../components/Home/Footer";
import Benefits from "../components/paymentMethods/Benefits";
import IntegrationOptions from "../components/paymentMethods/IntegrationOptions";
import AboutPageHero from "../components/paymentMethods/AboutPageHero";
import PaymentsList from "../components/paymentMethods/PaymentsList";

const PaymentMethods = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar classOption='navbar-light' />
      <AboutPageHero />
      <PaymentsList />
      <Benefits />
      <Footer />
    </Layout>
  );
};

export default PaymentMethods;
